module.exports = __webpack_public_path__ + "static/media/6.5-inch Screenshot 1.2350b6e7.jpeg";